export const TEACHERS = [
  {
    id: "ikram",
    name: "Ikram",
    title: "Danseuse hip-hop debout",
    course: "Hip-Hop · lundis",
    badge: "Équipe de France depuis 2020",
    photo: "/media/cours/prof_ikram.webp",
    bio: "Passionnée depuis l'âge de trois ans, Ikram voit son parcours décoller en 2014 à l'école Markadas. Membre de l'équipe de France, elle danse pour l'OL au Groupama Stadium, pour l'ASVEL à la LDLC Arena et enchaîne les titres internationaux. En cours, elle transmet technique, musicalité, énergie et attitude.",
    highlights: ["Championne du monde 2024", "Championne d'Europe 2023 & 2024", "Vice-championne du monde 2023", "Championne de France 2023 · 2024 · 2025"],
    values: ["Technique", "Musicalité", "Attitude"],
  },
  {
    id: "christina",
    name: "Christina AGS",
    title: "Artiste street art",
    course: "Street Art · mercredis",
    badge: "Peindre, transformer, partager",
    photo: "/media/cours/prof_christina.webp",
    bio: "Artiste d'origine arménienne formée aux Beaux-Arts, Christina Ags est spécialisée dans le street art, le live-painting, les fresques murales et la customisation. Son atelier mêle street art, peinture intuitive et expression personnelle, dans une ambiance bienveillante et accessible.",
    highlights: ["Performances live-painting", "Fresques murales collectives", "Customisation vinyles, plaques, A3", "Expositions personnelles & collectives"],
    values: ["Exprimer", "Créer", "S'inspirer"],
  },
  {
    id: "babass",
    name: "Bboy Babass",
    title: "Danseur de breakdance",
    course: "Breakdance · jeudis",
    badge: "Plus de 14 ans de pratique",
    photo: "/media/cours/prof_babass.webp",
    bio: "Originaire de Rillieux-la-Pape, Bboy Babass est un danseur de breakdance confirmé avec plus de 14 ans de pratique. Vainqueur de plusieurs compétitions régionales, il transmet les bases du break, la coordination, la musicalité et l'expression personnelle.",
    highlights: ["Vainqueur de compétitions régionales", "Shows au Groupama Stadium", "Pas debout · footwork · freezes", "Pédagogie énergie & exigence"],
    values: ["Respect", "Passion", "Partage", "Persévérance"],
  },
  {
    id: "hatem",
    name: "Bboy Hatem",
    title: "Danseur · chorégraphe · transmetteur",
    course: "Breakdance · jeudis",
    badge: "Bboy Breakers depuis 1987",
    photo: "/media/cours/prof_hatem.webp",
    bio: "Hatem Chraiti, artiste chorégraphe et membre fondateur des Bboy Breakers, pionniers du hip-hop lyonnais depuis 1987. Depuis 38 ans, il forme et inspire les nouvelles générations et organise battles, cours et stages dans toute l'Europe.",
    highlights: ["Membre fondateur des Bboy Breakers", "38 ans de transmission", "Organisateur de battles européens", "Stages intensifs pendant les vacances"],
    values: ["Respect", "Discipline", "Passion", "Partage"],
  },
];
